import { Theme, createStyles } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  topActions: {
    marginBottom: theme.spacing(4),
  },
  summaryGrid: {
    marginBottom: theme.spacing(1),
  },
  summaryCard: {
    height: '100%',
    borderRadius: 10,
  },
  summaryCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  summaryHeader: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '6px',
  },
  summaryLabel: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: '#4A4754',
  },
  summaryValue: {
    fontSize: 24,
    fontWeight: 700,
    color: '#DB5C0E',
    lineHeight: 1.2,
  },
  summaryCaption: {
    color: '#4A4754',
    fontSize: 14,
  },
  searchRow: {
    width: '100%',
  },
  searchField: {
    width: '100%',
  },
  contentWrapper: {
    border: '1px solid rgba(142, 139, 153, 0.25)',
    borderRadius: 10,
    marginTop: theme.spacing(4),
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  toolbar: {
    borderBottom: '1px solid rgba(142, 139, 153, 0.18)',
  },
  spacer: {
    flex: 1,
  },
  toolbarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  tabsRoot: {
    borderBottom: '1px solid rgba(142, 139, 153, 0.18)',
  },
  tableWrapper: {
    position: 'relative',
    overflowX: 'auto',
    minHeight: 220,
  },
  table: {
    minWidth: 980,
  },
  spinnerWrapper: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 1,
  },
  emptyState: {
    padding: theme.spacing(5, 3),
    textAlign: 'center',
    color: '#6A6776',
  },
  errorState: {
    padding: theme.spacing(5, 3),
    textAlign: 'center',
    color: '#A33A2B',
  },
});

export default styles;
